import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Record } from 'immutable';
import { useHistory } from 'react-router';

// Types
import { MeetingItem } from 'Shared/types/MeetingItem.type';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Selectors
import * as meetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';

// Helpers
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Components
import Checkmark from 'Shared/components/Checkmark/Checkmark';
import MeetingItemInput from 'Shared/components/MeetingItemInput/MeetingItemInput';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpOverflowExpand from 'Wpds/components/overflow-expand/WpOverflowExpand';

// Styles
import './AssociatedDiscussionTopic.scss';

type Props = {
  meetingItem: Record<MeetingItem>;
};

const AssociatedDiscussionTopic = ({ meetingItem }: Props) => {
  const history = useHistory();
  const associatedMeetingItemUuid = MeetingItemHelpers.getAssociatedMeetingItemUuid(meetingItem);

  const associatedMeetingItem = useSelector(state =>
    meetingItemSelectors.getMeetingItemByUuid(state, { meetingItemUuid: associatedMeetingItemUuid })
  ).get(associatedMeetingItemUuid);
  const isCompleted = MeetingItemHelpers.getCompleted(associatedMeetingItem);
  const workspaceId = MeetingItemHelpers.getWorkspaceId(associatedMeetingItem);

  const handleClick = useCallback(() => {
    history.push(PageUrlsUtil.makeWorkspaceMeetingItemCommentsUrl(workspaceId, associatedMeetingItemUuid));
  }, []);

  const baseClassName = 'AssociatedDiscussionTopic';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <div className={`${baseClassName}__header__icon`}>
          <WpIcon name="comment-alt-check" size="sm" />
        </div>
        <p className={`${baseClassName}__header__title`}>Discussion Topic</p>
      </div>
      <WpContainer>
        <WpContainerBody padding="05">
          <div className={`${baseClassName}__body`}>
            <div className={`${baseClassName}__body__checkmark`}>
              <Checkmark isCompleted={isCompleted} onClick={handleClick} />
            </div>
            <WpOverflowExpand maxHeight="75px">
              <div className={`${baseClassName}__body__input`}>
                <MeetingItemInput meetingItem={associatedMeetingItem} onClickCallback={handleClick} readonly />
              </div>
            </WpOverflowExpand>
          </div>
        </WpContainerBody>
      </WpContainer>
    </div>
  );
};

export default AssociatedDiscussionTopic;
